import { profile } from "../context/profile.js";
import Cookies from "js-cookie";

// Cookie configuration constants
const COOKIE_OPTIONS = {
  secure: true,
  sameSite: "none",
  path: "/",
};

const TOKEN_COOKIE_NAME = "token";
const LEGACY_REFRESH_TOKEN_COOKIE_NAME = "refreshToken";
const RESET_TOKEN_COOKIE_NAME = "reset-token";
const PENDING_BRANCH_LOGIN_KEY = "pending-branch-login";
const NOTIFY_STAFF_STORAGE_KEY = "broadcast_notify_staff";

export const setToken = (token) => {
  try {
    Cookies.set(TOKEN_COOKIE_NAME, token, { ...COOKIE_OPTIONS, expires: 1 }); // 1 day expiry
    return token;
  } catch (error) {
    console.error("Error setting token:", error);
    return null;
  }
};

export const getToken = () => {
  const storedToken = Cookies.get(TOKEN_COOKIE_NAME);
  return storedToken || profile.accessToken;
};

export const removeToken = () => {
  try {
    profile.accessToken = "";
    Cookies.remove(TOKEN_COOKIE_NAME, COOKIE_OPTIONS);
    Cookies.remove(LEGACY_REFRESH_TOKEN_COOKIE_NAME, COOKIE_OPTIONS);
  } catch (error) {
    console.error("Error removing tokens:", error);
  }
};

export const setResetToken = (token) => {
  try {
    Cookies.set(RESET_TOKEN_COOKIE_NAME, token, { ...COOKIE_OPTIONS, expires: 1 }); // 1 day expiry
    if (typeof window !== "undefined") {
      sessionStorage.setItem(RESET_TOKEN_COOKIE_NAME, token);
    }
  } catch (error) {
    console.error("Error reset tokens:", error);
  }
};

export const getResetToken = () => {
  try {
    const storedToken = Cookies.get(RESET_TOKEN_COOKIE_NAME);
    if (storedToken) return storedToken;
    if (typeof window === "undefined") return null;
    return sessionStorage.getItem(RESET_TOKEN_COOKIE_NAME) || null;
  } catch (error) {
    console.error("Error getting reset token:", error);
    return null;
  }
};

export const removeResetToken = () => {
  try {
    Cookies.remove(RESET_TOKEN_COOKIE_NAME, COOKIE_OPTIONS);
    if (typeof window !== "undefined") {
      sessionStorage.removeItem(RESET_TOKEN_COOKIE_NAME);
    }
  } catch (error) {
    console.error("Error removing reset token:", error);
  }
};

export const setPendingBranchLogin = (data) => {
  try {
    if (typeof window === "undefined") return false;
    sessionStorage.setItem(PENDING_BRANCH_LOGIN_KEY, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error("Error setting pending branch login:", error);
    return false;
  }
};

export const getPendingBranchLogin = () => {
  try {
    if (typeof window === "undefined") return null;

    const storedData = sessionStorage.getItem(PENDING_BRANCH_LOGIN_KEY);
    if (!storedData) return null;

    return JSON.parse(storedData);
  } catch (error) {
    console.error("Error getting pending branch login:", error);
    sessionStorage.removeItem(PENDING_BRANCH_LOGIN_KEY);
    return null;
  }
};

export const removePendingBranchLogin = () => {
  try {
    if (typeof window === "undefined") return;
    sessionStorage.removeItem(PENDING_BRANCH_LOGIN_KEY);
  } catch (error) {
    console.error("Error removing pending branch login:", error);
  }
};

// Hands off a staff selection to the broadcast page (always stored as an array).
export const setNotifyStaffSelection = (staffList) => {
  try {
    if (typeof window === "undefined") return false;
    sessionStorage.setItem(NOTIFY_STAFF_STORAGE_KEY, JSON.stringify(staffList));
    return true;
  } catch (error) {
    console.error("Error setting notify staff selection:", error);
    return false;
  }
};

export const getNotifyStaffSelection = () => {
  try {
    if (typeof window === "undefined") return null;

    const storedData = sessionStorage.getItem(NOTIFY_STAFF_STORAGE_KEY);
    if (!storedData) return null;

    return JSON.parse(storedData);
  } catch (error) {
    console.error("Error getting notify staff selection:", error);
    sessionStorage.removeItem(NOTIFY_STAFF_STORAGE_KEY);
    return null;
  }
};

export const removeNotifyStaffSelection = () => {
  try {
    if (typeof window === "undefined") return;
    sessionStorage.removeItem(NOTIFY_STAFF_STORAGE_KEY);
  } catch (error) {
    console.error("Error removing notify staff selection:", error);
  }
};

// Dark mode persistence functions
export const setDarkModePreference = (isDark) => {
  try {
    localStorage.setItem("darkMode", JSON.stringify(isDark));
  } catch (error) {
    console.error("Error setting dark mode preference:", error);
  }
};

export const getDarkModePreference = () => {
  try {
    const storedPreference = localStorage.getItem("darkMode");
    return storedPreference ? JSON.parse(storedPreference) : false;
  } catch (error) {
    console.error("Error getting dark mode preference:", error);
    return false;
  }
};
